import React from "react";
import styled from "styled-components";

const situacoes = {
  SOLICITADO: {
    label: "Solicitado",
    color: "#db7c2f",
    backgroundColor: "#fcf0df",
  },

  DISPONIVEL: {
    label: "Disponível",
    color: "#007f79",
    backgroundColor: "#e1f3f4",
  },
};

const ContentStatus = styled.div`
  background: ${(props) => situacoes[props.label]?.backgroundColor || "#fff"}};
  border: 0.5px solid
    ${(props) => situacoes[props.label]?.color || "#5c5c5cff"}};
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 8px;
  border-radius: 8px;
  color: #505050;
  font-weight: 600;
  gap: 4px;
  max-width: 194px;
  text-wrap: nowrap;
`;

const CircleColor = styled.div`
  width: 12px;
  height: 12px;
  background: ${(props) => situacoes[props.label]?.color || "#505050"};
  border-radius: 18px;
`;

const SituacaoExame = ({ laudoGerado }) => {
  const labelSituacao = laudoGerado ? "DISPONIVEL" : "SOLICITADO";

  const labelSituacaoVerificado = situacoes[labelSituacao]?.label ?? "";

  return (
    <ContentStatus label={labelSituacao}>
      <CircleColor label={labelSituacao} />
      {labelSituacaoVerificado}
    </ContentStatus>
  );
};

export default SituacaoExame;
